<template>
  <div :class="{ 'contact-persons': true, 'is-loading': !loaded }">
    <fieldset>
      <legend>
        Contact Persons in Israel
      </legend>

      <d-alert
        v-if="loadError"
        theme="warning"
        show
        class="text-center">
        An error occurred during loading contact persons.
      </d-alert>

      <d-row
        v-if="loaded && !loadError"
        class="pr-3 mb-3">
        <d-button
          theme="success"
          @click.prevent="addContact"
          outline
          class="ml-auto">
          Add new contact
        </d-button>
      </d-row>

      <d-row
        v-if="loaded && !loadError"
        class="pl-3 pr-3">
        <table class="table">
          <thead>
            <tr>
              <th>Is default contact?</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Company </th>
              <th>Email</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <israel-contact-persons-list-item
              v-for="(contactData, index) of contacts"
              :key="'contact-list-item-' + index"
              :contactData="contactData" />
          </tbody>
        </table>
      </d-row>

      <d-alert
        v-if="loaded && !loadError && contacts.length === 0"
        theme="light"
        show
        class="text-center">
        There are no contact persons
      </d-alert>
    </fieldset>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import IsraelContactPersonsListItem from './IsraelContactPersonsListItem.vue';

export default {
  name: 'israel-contact-persons',
  components: {
    'israel-contact-persons-list-item': IsraelContactPersonsListItem
  },
  data () {
    return {
      loaded: false,
      loadError: false,
      contacts: []
    };
  },
  mounted () {
    this.loadContacts();
    this.$bus.$on('israel-contact-persons-list-reload', this.reload);
  },
  methods: {
    loadContacts () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/israel-contact-persons/items',
        params: {
          pagination: 0
        },
        loadedKey: 'loaded',
        outputKey: 'contacts',
        errorKey: 'loadError'
      });
    },
    addContact () {
      let setAsDefault = false;

      if (this.contacts && !this.contacts.length) {
        setAsDefault = true;
      }

      this.$bus.$emit('show-israel-contact-person-popup', 'add', setAsDefault);
    },
    reload () {
      this.loaded = false;
      this.loadContacts();
      this.$bus.$on('contact-persons-list-reload');
    }
  },
  beforeDestroy () {
    this.$bus.$off('israel-contact-persons-list-reload', this.reload);
  }
}
</script>

<style lang="scss" scoped>
.contact-persons {
  margin: 30px 0;
  position: relative;

  &.is-loading {
    fieldset {
      min-height: 120px;
    }

    &:after {
      background: rgba(255, 255, 255, .66);
      content: "";
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }

    &:before {
      content: "Loading data...";
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      z-index: 1;
    }
  }
}
</style>
